import { render, staticRenderFns } from "./AI-class.vue?vue&type=template&id=7b778cc5"
import script from "./AI-class.vue?vue&type=script&lang=js"
export * from "./AI-class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports